import React, { forwardRef } from 'react';
import Barcode from 'react-barcode';

const PrintComponent = forwardRef((props, ref) => {
  const { formData, calculateOurPrice } = props;

  const currentDate = new Date();
  const formattedDate = `${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${currentDate
    .getDate()
    .toString()
    .padStart(2, '0')}/${currentDate.getFullYear().toString().slice(-2)}`;

  return (
    <div ref={ref} className='print-container'>
      <div className='print-header'>
        <div>KV Liquidation</div>
        <div>{formattedDate}</div>
      </div>
      <div className='print-title'>
        {formData.brand} <span style={{ color: 'red' }}>-</span>{' '}
        {formData.title}
      </div>
      <div className='print-retail-price-our-price'>
        <div className='print-retail-price'>
          Suggested Retail: <del>${formData.wasPrice || formData.price}</del>
        </div>
        <div className='print-our-price'>Our Price: ${calculateOurPrice()}</div>
      </div>
      <div className='barcode-container'>
        <div>
          <Barcode
            value={formData.item_id}
            format='CODE128'
            width={0.5}
            height={30}
            displayValue={false}
          />
        </div>
      </div>
    </div>
  );
});

export default PrintComponent;
